import { createAction } from 'redux-act';
import {
    ActivityResponse,
    IDeleteActivityLike,
    IFeedCommentRsponse,
    IFeedSuggestion,
    IGetFeed,
    IGetFeedComment,
    IGetFeedResponse,
    IGetPersistentFeed,
    ILikeActivity,
    ISaveSearchActivityPayload,
    IWarmTimeline,
    SearchSuggestion,
    types,
} from './types';
import { IErrorType } from '../../constants/types';
import { IGenericDocumentModifier } from '../../types/global/helper';
import { ILikeResponse } from '../account/types';

export const saveSearchActivity = createAction<ISaveSearchActivityPayload>(types.SAVE_ACTIVITY);
export const saveSearchActivitySuccess = createAction<ActivityResponse>(types.SAVE_ACTIVITY_SUCCESS);
export const saveSearchActivitFail = createAction<IErrorType>(types.SAVE_ACTIVITY_FAIL);

export const getMyActivities = createAction(types.GET_MY_ACTIVITIES);
export const getMyActivitiesSuccess = createAction<ActivityResponse[]>(types.GET_MY_ACTIVITIES_SUCCESS);
export const getMyActivitiesFail = createAction<IErrorType>(types.GET_MY_ACTIVITIES_FAIL);

export const getSearchSuggestions = createAction(types.GET_SEARCH_SUGGESTIONS);
export const getSearchSuggestionsSuccess = createAction<SearchSuggestion[]>(types.GET_SEARCH_SUGGESTIONS_SUCCESS);
export const getSearchSuggestionsFail = createAction<IErrorType>(types.GET_SEARCH_SUGGESTIONS_FAIL);

export const hideMyActivity = createAction<IGenericDocumentModifier>(types.HIDE_MY_ACTIVITY);
export const hideMyActivitySuccess = createAction<ActivityResponse>(types.HIDE_MY_ACTIVITY_SUCCESS);
export const hideMyActivityFail = createAction<IErrorType>(types.HIDE_MY_ACTIVITY_FAIL);
export const resetActivityData = createAction(types.RESET_ACTIVITY_DATA);

export const getActivityFeed = createAction<IGetFeed>(types.GET_ACTIVITY_FEED);
export const getActivityFeedSuccess = createAction<IGetFeedResponse>(types.GET_ACTIVITY_FEED_SUCCESS);
export const getActivityFeedFail = createAction<IErrorType>(types.GET_ACTIVITY_FEED_FAIL);

export const getFeedSuggestion = createAction(types.GET_FEED_SUGGESTION);
export const getFeedSuggestionSuccess = createAction<IFeedSuggestion>(types.GET_FEED_SUGGESTION_SUCCESS);
export const getFeedSuggestionFail = createAction<IErrorType>(types.GET_FEED_SUGGESTION_FAIL);

export const getFeedComments = createAction<IGetFeedComment>(types.GET_FEED_COMMENT);
export const getFeedCommentsSuccess = createAction<IFeedCommentRsponse>(types.GET_FEED_COMMENT_SUCCESS);
export const getFeedCommentsFail = createAction<IErrorType>(types.GET_FEED_COMMENT_FAIL);

export const likeActivity = createAction<ILikeActivity>(types.LIKE_ACTIVITY);
export const likeActivitySuccess = createAction<ILikeResponse>(types.LIKE_ACTIVITY_SUCCESS);
export const likeActivityFail = createAction<IErrorType>(types.LIKE_ACTIVITY_FAIL);

export const deleteActivityLike = createAction<IDeleteActivityLike>(types.DELETE_ACTIVITY_LIKE);
export const deleteActivityLikeSuccess = createAction<ILikeResponse>(types.DELETE_ACTIVITY_LIKE_SUCCESS);
export const deleteActivityLikeFail = createAction<IErrorType>(types.DELETE_ACTIVITY_LIKE_FAIL);

/** The below is exploratory. It was an attempt to fetch the timeiline vis
 * s3. I noticed it was slowing down the system so it si currenty not in use
 */
export const getPersistentFeed = createAction<IGetPersistentFeed>(types.GET_PERSISTENT_FEED);
export const getPersistentFeedSuccess = createAction<IGetFeedResponse>(types.GET_PERSISTENT_FEED_SUCCESS);
export const getPersistentFeedFail = createAction<IErrorType>(types.GET_PERSISTENT_FEED_FAIL);

export const warmTimeline = createAction<IWarmTimeline>(types.WARM_TIMELINE);
export const warmTimelineSuccess = createAction(types.WARM_TIMELINE_SUCCESS);
export const warmTimelineFail = createAction<IErrorType>(types.WARM_TIMELINE_FAIL);
